import { errorValidation } from './utils';

let url = $(location).attr('href').split('/').splice(0, 5).join('/');
let segments = url.split('/');
let lang = segments[3];

let orderUserPhone = $('#order_user_phone');
/**
 * Init intlTelInput
 */
[orderUserPhone].forEach(phoneInput => {
	phoneInput.inputmask({
		mask: 'V9{1,15}',
		definitions: {
			V: {
				// validator: '^[1-9][0-9]*$',
				validator: '^[0-9]+$',
			},
		},
		placeholder: '',
	});

	// Set the initial country code on page load
	let initialCountryCode = phoneInput.intlTelInput(
		'getSelectedCountryData'
	).dialCode;
	let countryCodeInput = phoneInput
		.closest('.input-wrapper')
		.find('.country-code');
	countryCodeInput.val(initialCountryCode);

	// On blur: validate
	phoneInput.focusout(function () {
		if ($.trim(phoneInput.val())) {
			if (phoneInput.intlTelInput('isValidNumber')) {
				console.log('isValidNumber');
				// Save country code
				countryCodeInput.val(initialCountryCode);
			} else {
				phoneInput.addClass('_error');
			}
		}
	});

	// On keydown: reset
	phoneInput.keydown(function () {
		phoneInput.removeClass('_error');
	});
});

/**
 * Add custom validation method
 */
$.validator.addMethod(
	'validateOrderPhone',
	function (value, element) {
		return $(element).intlTelInput('isValidNumber');
	},
	window.translations.phoneInvalid
);

/**
 * Validate forms
 */
(() => {
	// Order User
	$("form[name='order_user']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'order_user[name]': {
				required: true,
			},
			'order_user[email]': {
				required: true,
				email: true,
			},
			'order_user[phone]': {
				required: true,
				// validateOrderPhone: true,
			},
		},
		messages: {
			'order_user[name]': {
				required: window.translations.required,
			},
			'order_user[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
			'order_user[phone]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});

	$("form[name='order_privacy']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'order_privacy[privacy]': {
				required: true,
			},
		},
		messages: {
			'order_privacy[privacy]': {
				required: window.translations.checkboxRequired,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});

	$("form[name='order_payment']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'order_payment[payment]': {
				required: true,
			},
		},
		messages: {
			'order_payment[payment]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();

const deliveryValidation = () => {
	// Determine the active tab
	let activeTab = $('.order__tab._active').index();
	let rules = {};
	let messages = {};

	if (activeTab === 0) {
		// First tab rules and messages
		rules['order_delivery[city]'] = { required: true };
		rules['order_delivery[address]'] = { required: true };
		messages['order_delivery[city]'] = {
			required: window.translations.required,
		};
		messages['order_delivery[address]'] = {
			required: window.translations.required,
		};
	} else if (activeTab === 1) {
		// Second tab rules and messages
		rules['order_delivery[store]'] = { required: true };
		messages['order_delivery[store]'] = {
			required: window.translations.required,
		};
	}

	// Apply new validation rules
	const deliveryForm = $("form[name='order_delivery']");
	deliveryForm.validate().destroy();
	deliveryForm.validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: rules,
		messages: messages,
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
};

$('.order__tab').on('click', function () {
	deliveryValidation();
});

/**
 * Check if all forms are valid
 */
const validateForms = () => {
	deliveryValidation();

	let orderUserValid = $("form[name='order_user']").valid();
	let orderDeliveryValid = $("form[name='order_delivery']").valid();
	let orderPaymentValid = $("form[name='order_payment']").valid();

	let orderPrivacyValid = $("form[name='order_privacy']").valid();

	return orderUserValid && orderDeliveryValid && orderPaymentValid && orderPrivacyValid;
};

/**
 * Gather data from all forms and send via AJAX
 */
$('#create_order').on('click', function (event) {
	event.preventDefault();
	// validateOrderTabsForm(true);

	if (validateForms()) {
		let orderUserData = $("form[name='order_user']").serializeArray();
		let orderDeliveryData = $("form[name='order_delivery']").serializeArray();
		let orderPaymentData = $("form[name='order_payment']").serializeArray();
		let orderOptionalData = $("form[name='order_optional']").serializeArray();
		let orderPrivacyData = $("form[name='order_privacy']").serializeArray();

		let allData = {};
		$.each(orderUserData, function (index, field) {
			allData[field.name] = field.value;
		});

		let activeTab = $('.order__tab._active').index();
		if (activeTab === 0) {
			// First tab: include only 'city' and 'address' and 'express_delivery'
			$.each(orderDeliveryData, function (index, field) {
				if (
					field.name === 'order_delivery[city]' ||
					field.name === 'order_delivery[address]' ||
					field.name === 'order_delivery[express_delivery]'
				) {
					allData[field.name] = field.value;
				}
			});
			allData['order_delivery[delivery_type]'] = 1;
		} else if (activeTab === 1) {
			// Second tab: include only 'store'
			$.each(orderDeliveryData, function (index, field) {
				if (field.name === 'order_delivery[store]') {
					allData[field.name] = field.value;
				}
			});
			allData['order_delivery[delivery_type]'] = 2;
		}

		$.each(orderPaymentData, function (index, field) {
			allData[field.name] = field.value;
		});
		$.each(orderOptionalData, function (index, field) {
			allData[field.name] = field.value;
		});
		$.each(orderPrivacyData, function (index, field) {
			allData[field.name] = field.value;
		});

		$('.loader_replace').html(loader);
		console.log('allData: ', allData);

		$.ajax({
			url: '/' + lang + '/ajax/order', // путь к обработчику
			type: 'POST', // метод отправки,
			data: allData,
			success: function (response) {
				let result = JSON.parse(response);
				if (result.status == 'success') {
					window.location.href =
						'/' + lang + '/success?order_id=' + result.order_id;
				} else {
					location.reload();
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	}
});
